var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "column designer-result" }, [
    _vm.loading
      ? _c("div", { staticClass: "designer-result__loader" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "designer-results-image" }, [
      _c(
        "div",
        {
          staticClass: "generated-sign-container",
          attrs: { id: "signcontainer" },
        },
        [
          _c("div", { staticClass: "generator-image" }, [
            _c(
              "div",
              {
                staticClass: "generated-image",
                attrs: { "data-material-id": "1" },
              },
              [
                _c("canvas", {
                  ref: "canvas",
                  staticClass: "generator-canvas",
                  attrs: { id: "generator-canvas" },
                }),
              ]
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.overSizedText
      ? _c("div", { staticClass: "motif-to-big" }, [
          _vm.languageStrings.motif_to_big
            ? _c("span", [_vm._v(_vm._s(_vm.languageStrings.motif_to_big))])
            : _c("span", [
                _vm._v(
                  "Woops, the design is to big to fit the sign, please adjust."
                ),
              ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.error ? _c("div", [_vm._v("No product image found.")]) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }